import {
  Button,
  Modal,
  Form,
  Input,
  Flex,
  Typography,
  message,
  Select,
  Space,
  DatePicker,
} from "antd";
import React, { forwardRef, useState, useImperativeHandle } from "react";
import { EditOutlined, QuestionCircleOutlined } from "@ant-design/icons";
import http from "@/utils/http";
import api from "@/utils/api";
import { debounce } from "lodash";

const AddModal = forwardRef((props, ref) => {
  const { onSuccess } = props;
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);
  const [officeList, setOfficeList] = useState([]);
  const [loadingCron, setLoadingCron] = useState(false);
  const [businessTypeList, setBusinessTypeList] = useState([]);
  const [cronModalVisible, setCronModalVisible] = useState(false);


  useImperativeHandle(ref, () => ({
    setModelAdd: async () => {
      try {
        console.log("Modal opening...");
        form.resetFields();
        setVisible(true);
  
      } catch (error) {
        message.error("Failed to initialize modal data");
        console.error("Initialization error:", error);
      }
    },
  }));





  const onFinishAdd = async (values) => {
    try {
      setLoading(true);
 
      const queryParams = {
        businessType: values.businessType,
        remark: values.remark,
      };
      // console.log(queryParams);
      const response = await http.post(`${api.getAddVo}`, queryParams);
      if (response.code === "1") {
        message.success("Add  successfully");
        setVisible(false);
        form.resetFields();
        onSuccess?.();
      } else {
        message.error(response.msg);
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const layout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 16 },
  };


  return (
    <>
      <Modal
        title={
          <Flex justify="flex-start" align="flex-start" className="model_title">
            <EditOutlined className="model_title_mr10" />
            <Typography.Title level={4} className="mg">
              Add Ap License
            </Typography.Title>
          </Flex>
        }
        width="50%"
        open={visible}
        onCancel={() => {
          setVisible(false);
          form.resetFields();
        }}
        footer={
          <div style={{ display: "flex", justifyContent: "center", gap: "16px" }}>
          <Button
            key="back"
            onClick={() => {
              setVisible(false);
              form.resetFields();
            }}
          >
            Cancel
          </Button>
          <Button
            key="submit"
            type="primary"
            loading={loading}
            onClick={() => form.submit()}
          >
            Submit
          </Button>
        </div>}
        centered
      >
        <Flex justify="space-between" align="flex-start">
          <div className="model_top" style={{ width: "100%" }}>
            <div className="model_content">
              <Form
                {...layout}
                name="AddForm"
                onFinish={onFinishAdd}
                form={form}
                // initialValues={{ userType: 1 }}
                labelCol={{
                  style: {
                    width: "150px",
                  },
                }}
                wrapperCol={{
                  style: {
                    flex: 1,
                  },
                }}
              >
   

                {/* <Form.Item name="businessType" label="Business Type">
                  <Select
                    placeholder=""
                    mode="multiple"
                    options={businessTypeList}
                    onSearch={handleEmailSearch}
                    allowClear
                    showSearch
                    optionFilterProp="label"
                    filterOption={(input, option) =>
                      option.label.toLowerCase().includes(input.toLowerCase())
                    }
                  />
                </Form.Item> */}
  <Form.Item name="businessType" label="Business Type">
                  <Input placeholder="Please enter Business Type" allowClear />
                </Form.Item>
            
                <Form.Item name="remark" label="Remark">
                  <Input placeholder="Please enter Remark" allowClear />
                </Form.Item>
            
              </Form>
            </div>
          </div>
        </Flex>
      </Modal>
 
    </>
  );
});

export default AddModal;
